/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard PRO React icons

import "assets/theme/base/animation.css";

import Icon from "@mui/material/Icon";


import { useSoftUIController } from "context";


let sportSelected = null;
let refreshTimeout = null;
let prevSports = [];
let currentSports = [];

function Sidenav({ informParent, sidenavCollapse, items, eventTypeSelected, parentSportSelected }) {
  const [controller, dispatch] = useSoftUIController();
  const { sports, sports_numbers } = controller;
  //console.log("sidenav run...");
  const [sportsList, setSportsList] = useState([]);
  const [collapsedSidenav, setCollapsedSidenav] = useState(false);
  const [sportSelectedSideNav, setSportSelectedSideNav] = useState(null);
  const [eventType, setEventType] = useState(null);

  async function rendersNavItems(items) {
    if (!items) return;

    if (currentSports.length > 0) prevSports = [...currentSports];
    let sidenavItems = [];

    let sportPrevImage = sportSelected
      ? prevSports.find((item) => item.id === sportSelected.id)
      : null;
    let refreshParent = false;
    for (let index = 0; index < items.length; index++) {
      const sport = items[index];
      if (!sport.id) continue;
      const sportFound = sports.find((item) => item.id === sport.id);
      sidenavItems.push({
        id: sport.id,
        icon: <Icon>sports_{sportFound.name.replace(" ", "").toLowerCase()}_outlined_icon</Icon>,
        label: sportFound.name,
        ip_numbers: sport.inplay + "/" + sport.inplayAll,
        pre_numbers: sport.pregame + "/" + sport.pregameAll,
        hasInplayEvents: sport.inplay > 0 ? true : false,
        hasPregameEvents: sport.pregame > 0 ? true : false,
      });
      if (sportPrevImage && sport.id === sportPrevImage.id) {
        if (sportPrevImage.ip_numbers != sport.inplay + "/" + sport.inplayAll) {
          refreshParent = true;
        }
      }
    }
    if (!sportSelected && sidenavItems.length > 0) {
      sportSelected = { id: sidenavItems[0].id, name: sidenavItems[0].label };
      setSportSelectedSideNav(sportSelected);
      if (informParent) informParent(sidenavItems[0].id, sidenavItems[0].label, eventType);
    } else {
      if (refreshParent && informParent) {
        informParent(
          sportSelected ? sportSelected.id : sidenavItems[0].id,
          sidenavItems[0].label,
          eventType
        );
      }
    }
    currentSports = [...sidenavItems];
    setSportsList(sidenavItems);
    startTimerCall();
    if (parentSportSelected) {
      let itemSelected = sidenavItems.find((s) => s.id == parentSportSelected);
      setSportSelectedSideNav(itemSelected);
    }
  }

  function errorHandling(error) {
    if (
      error.message === "Network Error" &&
      error.code === "ERR_NETWORK" &&
      error.name === "AxiosError"
    ) {
      console.log(error);
    }
  }

  function startTimerCall() {
    refreshTimeout = setInterval(rendersNavItems, 60 * 1000, items);
  }

  function setSelectedSport(e, id, name) {
    e.preventDefault();
    sportSelected = { id: id, name: name };
    setSportSelectedSideNav(sportSelected);
    if (informParent) informParent(id, name, eventType);
  }

  function collapseSidenav() {
    let collapsed = collapsedSidenav;
    setCollapsedSidenav(!collapsed);
    sidenavCollapse(!collapsed);
  }

  function hanndleEventType(e, type) {
    e.preventDefault();

    setEventType(type);
    if (informParent) informParent(sportSelected.id, sportSelected.name, type);
  }

  useEffect(() => {
    return () => {
      sportSelected = null;
      setSportSelectedSideNav(sportSelected);
      if (refreshTimeout) {
        clearInterval(refreshTimeout);
        refreshTimeout = null;
      }
    };
  }, []);

  useEffect(() => {
    //console.log(refreshTimeout);
  }, [refreshTimeout]);

  useEffect(() => {
    if (sports && sports_numbers) rendersNavItems(sports_numbers);
  }, [sports, sports_numbers]);

  useEffect(() => {
    if (eventTypeSelected) setEventType(eventTypeSelected);
  }, [eventTypeSelected]);

  return (
    <Card
      sx={{
        borderRadius: ({ borders: { borderRadius } }) => borderRadius.lg,
        position: "sticky",
        top: "1%",
      }}
    >
      <SoftBox style={{ backgroundColor: "rgb(248, 249, 250)" }}>
        <Grid container>
          <Grid item xs={6}>
            <SoftBox id="pregame_button_holder">
              <Grid container>
                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    // borderLeft: "5px solid rgb(4, 95, 130)",
                    backgroundColor:
                      eventType == "pregame" ? "rgba(255, 255, 255, 1)" : "rgba(0, 0, 0, 0.01)",
                    padding: "5px 0px 5px 5px",
                    borderRadius: "10px 10px 0px 0px",
                  }}
                  component="a"
                  variant="button"
                  href={""}
                  onClick={(e) => hanndleEventType(e, "pregame")}
                  className={eventType == "pregame" ? "pregame-button-selected" : "pregame-button"}
                >
                  <SoftTypography
                    className="monitoring-pregame-tab"
                    style={{
                      opacity: eventType == "pregame" ? 1 : 0.4,
                      fontWeight: eventType == "pregame" ? 500 : 400,
                    }}
                  >
                    <Icon>today_outlined_icon</Icon> Pregame
                  </SoftTypography>
                  <div
                    className={
                      "sport-counter-pregame-num " +
                      (eventType && eventType == "pregame" ? eventType + "-events" : "")
                    }
                  >
                    {sports_numbers ? sports_numbers.find((s) => s.id == null).pregame : 0} /{" "}
                    {sports_numbers ? sports_numbers.find((s) => s.id == null).pregameAll : 0}
                  </div>
                </Grid>
              </Grid>
            </SoftBox>
          </Grid>
          <Grid item xs={6}>
            <SoftBox id="inplay_button_holder">
              <Grid container>
                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    // borderLeft: "5px solid rgb(20, 130, 4)",
                    backgroundColor:
                      eventType == "inplay" ? "rgba(255, 255, 255, 1)" : "rgba(0, 0, 0, 0.01)",
                    padding: "5px 0px 5px 5px",
                    borderRadius: "10px 10px 0px 0px",
                  }}
                  component="a"
                  variant="button"
                  href={""}
                  onClick={(e) => hanndleEventType(e, "inplay")}
                  className={eventType == "inplay" ? "inplay-button-selected" : "inplay-button"}
                >
                  <SoftTypography
                    className="monitoring-inplay-tab"
                    style={{
                      opacity: eventType == "inplay" ? 1 : 0.4,
                      fontWeight: eventType == "inplay" ? 500 : 400,
                    }}
                  >
                    <Icon>slow_motion_video_icon</Icon> Live
                  </SoftTypography>
                  <div
                    className={
                      "sport-counter-inplay-num " +
                      (eventType && eventType == "inplay" ? eventType + "-events" : "")
                    }
                  >
                    {sports_numbers ? sports_numbers.find((s) => s.id == null).inplay : 0} /{" "}
                    {sports_numbers ? sports_numbers.find((s) => s.id == null).inplayAll : 0}
                  </div>
                </Grid>
              </Grid>
            </SoftBox>
          </Grid>
        </Grid>
      </SoftBox>
      <SoftBox
        component="ul"
        display={eventType === "pregame" ? "flex" : "none"}
        flexDirection="column"
        p={1}
        m={0}
        sx={{
          listStyle: "none",
          height: "max-content",
          maxHeight: "100%",
          overflow: "auto",
          scrollbarWidth: "thin",
          padding: collapsedSidenav ? "0px" : "",
        }}
      >
        {sportsList.map(({ id, icon, label, pre_numbers, hasPregameEvents }, key) => {
          return (
            <SoftBox key={`item-${key}`} component="li" pt={key === 0 ? 0 : 0.5} title={label}>
              <SoftTypography
                component="a"
                href={""}
                className={
                  sportSelectedSideNav && id == sportSelectedSideNav.id
                    ? "selected-sport"
                    : "regular-sport"
                }
                variant="button"
                fontWeight="regular"
                color={sportSelectedSideNav && id == sportSelectedSideNav.id ? "text" : "secondary"}
                textTransform="capitalize"
                sx={({
                  borders: { borderRadius },
                  functions: { pxToRem },
                  palette: { light },
                  transitions,
                }) => ({
                  display: "flex",
                  alignItems: "center",
                  borderRadius: borderRadius.md,
                  padding: `${pxToRem(10)} ${pxToRem(16)}`,
                  transition: transitions.create("background-color", {
                    easing: transitions.easing.easeInOut,
                    duration: transitions.duration.shorter,
                  }),

                  "&:hover": {
                    backgroundColor: light.main,
                  },
                })}
                onClick={(e) => setSelectedSport(e, id, label)}
              >
                <SoftBox mr={1} lineHeight={1}>
                  <img
                    className={"sport-logo " + label.replace(/ /g, "").toLowerCase() + "-logo"}
                  ></img>
                </SoftBox>
                <SoftBox
                  lineHeight={1}
                  style={{ display: collapsedSidenav ? "none" : "", width: "100%" }}
                >
                  {label}
                </SoftBox>
                <div
                  className={
                    (hasPregameEvents ? "hasEvents " : "") +
                    "" +
                    (prevSports.find((item) => item.id === id) &&
                    prevSports.find((item) => item.id === id).pre_numbers !== pre_numbers
                      ? "sport-counter-num blink-class"
                      : "sport-counter-num")
                  }
                >
                  {pre_numbers}
                </div>
              </SoftTypography>
            </SoftBox>
          );
        })}
      </SoftBox>
      <SoftBox
        id="inplay_list_holder"
        component="ul"
        display={eventType === "inplay" ? "flex" : "none"}
        flexDirection="column"
        p={1}
        m={0}
        sx={{
          listStyle: "none",
          height: "max-content",
          maxHeight: "100%",
          overflow: "auto",
          scrollbarWidth: "thin",
          padding: collapsedSidenav ? "0px" : "",
        }}
      >
        {sportsList.map(({ id, icon, label, ip_numbers, hasInplayEvents }, key) => {
          return (
            <SoftBox key={`item-${key}`} component="li" pt={key === 0 ? 0 : 0.5} title={label}>
              <SoftTypography
                component="a"
                href={""}
                className={
                  sportSelectedSideNav && id == sportSelectedSideNav.id
                    ? "selected-sport"
                    : "regular-sport"
                }
                variant="button"
                fontWeight="regular"
                color={sportSelectedSideNav && id == sportSelectedSideNav.id ? "text" : "secondary"}
                textTransform="capitalize"
                sx={({
                  borders: { borderRadius },
                  functions: { pxToRem },
                  palette: { light },
                  transitions,
                }) => ({
                  display: "flex",
                  alignItems: "center",
                  borderRadius: borderRadius.md,
                  padding: `${pxToRem(10)} ${pxToRem(16)}`,
                  transition: transitions.create("background-color", {
                    easing: transitions.easing.easeInOut,
                    duration: transitions.duration.shorter,
                  }),

                  "&:hover": {
                    backgroundColor: light.main,
                  },
                })}
                onClick={(e) => setSelectedSport(e, id, label)}
              >
                <SoftBox mr={1} lineHeight={1}>
                  <img
                    className={"sport-logo " + label.replace(/ /g, "").toLowerCase() + "-logo"}
                  ></img>
                </SoftBox>
                <SoftBox
                  lineHeight={1}
                  style={{ display: collapsedSidenav ? "none" : "", width: "100%" }}
                >
                  {label}
                </SoftBox>
                <div
                  className={
                    (hasInplayEvents ? "hasEvents " : "") +
                    "" +
                    (prevSports.find((item) => item.id === id) &&
                    prevSports.find((item) => item.id === id).ip_numbers !== ip_numbers
                      ? "sport-counter-num blink-class"
                      : "sport-counter-num")
                  }
                >
                  {ip_numbers}
                </div>
              </SoftTypography>
            </SoftBox>
          );
        })}
      </SoftBox>
    </Card>
  );
}

Sidenav.propTypes = {
  informParent: PropTypes.func,
  sidenavCollapse: PropTypes.func,
  items: PropTypes.array,
  eventTypeSelected: PropTypes.string,
  parentSportSelected: PropTypes.number,
};

export default Sidenav;
